import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-605777bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transfer-user ws_pt20" }
const _hoisted_2 = { class: "send box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "发货方", -1))
const _hoisted_4 = { class: "send" }
const _hoisted_5 = { class: "line" }
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-send" }, null, -1))
const _hoisted_8 = { class: "receive box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "收货方", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, " 说明：此处的发货为虚拟发货，不产生物流和费用，仅做物权的转移。物权转移时，设备的使用权和归属权发生转移，但设备迁出前的历史数据仍归属于迁出方，设备迁出后产生的新数据归属于迁入方。 ", -1))
const _hoisted_11 = { class: "dialog-footer" }

import { ref, computed, watch } from 'vue'
import { deviceBatchDelivery } from '@/api'
import { CODE_ENUM } from '@/common'
import Selecttenant from '@/components/select-tenant'
import { useTenantStore } from '@/stores/tenant'
import { queryTenantTreeListContainOrg } from '@/api'
import { isEmpty } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'transfer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const tenantStore = useTenantStore()

const props = __props
const $emit = __emit

watch(
  () => props.visible,
  () => {
    if (!props.visible) {
      toOrgId.value = undefined
    } else {
      queryTenant()
    }
  }
)

const disabled = computed(() => {
  return !toOrgId.value || toOrgId.value === tenantStore.topOrgId
})

const loading = ref(false)

const toOrgId = ref()

const toDelivery = async () => {
  const deviceIds = props.data.map((item: any) => item.deviceId)
  const fromOrgId = props.data[0].topOrgId

  loading.value = true
  const res: any = await deviceBatchDelivery({
    deviceIds,
    fromOrgId,
    toOrgId: toOrgId.value,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    $emit('success')
    handleClose()
  }
}

const treeList: any = ref([])
const queryTenant = async () => {
  const res: any = await queryTenantTreeListContainOrg()
  if (res?.code === CODE_ENUM.SUCCESS) {
    treeList.value = deepFormat(res.data || [])
  }
}

const deepFormat = (list: any, level = 0) => {
  if (isEmpty(list)) {
    return
  }
  return list.map((item: any) => {
    const { children, id, name, ...p } = item
    return {
      ...p,
      value: id,
      id,
      label: name,
      // children: deepFormat(children, level + 1),
      level: level + 1,
      disabled: id === tenantStore.topOrgId,
    }
  })
}
const handleClose = () => {
  $emit('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_CaretRight = _resolveComponent("CaretRight")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: "流转",
    width: "718",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_11, [
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: toDelivery,
          disabled: disabled.value,
          loading: loading.value,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(tenantStore).topOrgInfo.orgName), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_CaretRight, { size: "20" })
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_tree_select, {
            filterable: "",
            "check-strictly": "",
            "default-expand-all": "",
            modelValue: toOrgId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toOrgId).value = $event)),
            placeholder: "请选择收货方",
            data: treeList.value,
            "render-after-expand": true
          }, null, 8, ["modelValue", "data"])
        ])
      ]),
      _hoisted_10
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})